<template>
  <v-card>
    <v-card-title>
      Записване за предстоящи събития
    </v-card-title>
    <v-card-text>
      <template>
          <div v-if="this.subscribed" class="form-inline">
            <v-alert class="w-100" type="success" >
              Вие се записахте успешно, ще Ви информираме за предстоящи събития.
            </v-alert>
          </div>
          <div v-else class="form-inline" >
            <div class="form-group col-12 col-sm-4">
              <v-text-field v-model="client.name" label="Име" required></v-text-field>
            </div>
            <div class="form-group col-12 col-sm-4">
              <v-text-field v-model="client.email" label="Email" required></v-text-field>
            </div>

            <div class="col-12 col-sm-4 justify-content-end text-right">
              <v-btn class="primary" @click="subscribeToNewsletter()">Записване</v-btn>
            </div>
          </div>
      </template>
    </v-card-text>
  </v-card>
</template>
<script>

    export default {
        props: [
            'event'
        ],
        computed: {},
        data() {
            return {
                client: {
                    name: '',
                    email: ''
                },
                subscribed: false
            }
        },
        methods: {
            subscribeToNewsletter() {
                let data = {
                    name: this.client.name,
                    email: this.client.email,
                    event_id: this.event.id
                };

                axios.post('/subscribe', data).then((response) => {
                    this.subscribed = true
                }).catch((error) => {
                    alert(error.response.data.message);
                }).finally(() => {

                })
            }
        }
    }
</script>
